import { GlassCard } from '@/components/ui/glass-card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { BookOpen, Clock, Users, ArrowRight } from 'lucide-react';

const CourseOverview = () => {
  const modules = [
    {
      number: 1,
      title: "Basis Modul",
      description: "Wirksame Techniken zur Aktivierung der Selbstheilungskräfte",
      highlights: ["Fühlen der Aura und Chakren", "Transformations- und Selbstheilungsprozesse", "Meditation"]
    },
    {
      number: 2,
      title: "Erweiterung Basis Modul",
      description: "Vertiefung auf seelisch-geistiger Ebene",
      highlights: ["Organe der Seele", "Erweiterte Reinigungstechniken", "Innere Sinne aktivieren"]
    },
    {
      number: 3,
      title: "Lebensbaum",
      description: "Zugang zu allen Schöpfungswelten der Seele",
      highlights: ["11 Innere Ebenen", "Karmische Verhärtungen lösen", "Inneres Schöpferzentrum"]
    },
    {
      number: 4,
      title: "Spirituelle Lebenskraft Aktivierung",
      description: "Das stärkste Instrument der Selbstmeisterung",
      highlights: ["Spirituelle Lebenskraft", "Körper- und Zellbewusstsein", "Seelenplan erkennen"]
    },
    {
      number: 5,
      title: "Solar Torus®",
      description: "Direkter Kontakt mit dem Bewusstseinsfeld",
      highlights: ["Torus-Energiefeld", "Platonische Körper", "Einheit mit dem Kosmos"]
    }
  ];

  return (
    <section className="py-20 bg-orange-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary-deep mb-4">
            Lehrgangsübersicht
          </h2>
          <p className="text-xl text-primary-deep/80 max-w-3xl mx-auto">
            Der gesamte Lehrgang der "Prana Kundalini-Therapie®" beinhaltet 5 aufeinander aufbauende Module
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {modules.map((module, index) => (
            <GlassCard 
              key={index}
              className="p-6 bg-white/90 border-white/30 hover:bg-white/95 transition-all duration-300 hover:shadow-2xl"
            >
              <div className="text-center mb-6">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-main text-white text-2xl font-bold mb-4">
                  {module.number}
                </div>
                <h3 className="text-xl font-bold text-primary-deep mb-2">
                  Modul {module.number}
                </h3>
                <h4 className="text-lg font-semibold text-primary-main mb-3">
                  {module.title}
                </h4>
                <p className="text-primary-deep/80 leading-relaxed mb-4">
                  {module.description}
                </p>
              </div>

              <div className="space-y-2 mb-6">
                {module.highlights.map((highlight, idx) => (
                  <div key={idx} className="flex items-center space-x-2 text-sm text-primary-deep/70">
                    <div className="w-2 h-2 bg-primary-light rounded-full shrink-0"></div>
                    <span>{highlight}</span>
                  </div>
                ))}
              </div>

              <div className="flex items-center justify-between text-sm text-primary-deep/70 border-t pt-4 border-primary-main/20">
                <div className="flex items-center space-x-2">
                  <Clock className="h-4 w-4" />
                  <span>2 Tage</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Users className="h-4 w-4" />
                  <span>Präsenz</span>
                </div>
              </div>
            </GlassCard>
          ))}

          {/* Special module 6 card */}
          <GlassCard className="p-6 bg-white/90 border-white/30 hover:bg-white/95 transition-all duration-300">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-light text-primary-deep text-2xl font-bold mb-4">
                6
              </div>
              <h3 className="text-xl font-bold text-primary-deep mb-2">
                Zusatzmodul
              </h3>
              <h4 className="text-lg font-semibold text-primary-main mb-3">
                Lebensgarten
              </h4>
              <p className="text-primary-deep/80 leading-relaxed mb-4">
                Aufschulung für Absolventen aller Module
              </p>
              <div className="text-sm text-primary-deep font-medium">
                Nur für Absolventen
              </div>
            </div>
          </GlassCard>
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <GlassCard className="p-8 max-w-2xl mx-auto bg-white/90 border-white/30 hover:bg-white/95 transition-all duration-300">
            <h3 className="text-2xl font-bold text-primary-deep mb-4">
              Bereit für Ihre spirituelle Reise?
            </h3>
            <p className="text-primary-deep/80 mb-6">
              Für das Frühjahr 2025 gibt es noch wenige freie Plätze! 
              Sichern Sie sich jetzt Ihren Platz in der Prana Kundalini-Therapie® Ausbildung.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="bg-primary-main hover:bg-primary-main/90 text-white">
                <Link to="/module">
                  <BookOpen className="mr-2 h-5 w-5" />
                  Module Details
                </Link>
              </Button>
              
              <Button asChild size="lg" variant="outline" className="border-primary-deep text-primary-deep hover:bg-primary-deep hover:text-white">
                <Link to="/anmeldung">
                  Jetzt Anmelden
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </GlassCard>
        </div>
      </div>
    </section>
  );
};

export default CourseOverview;